import { jsx as _jsx } from "react/jsx-runtime";
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import AsNumeral from '../../../vendors/asNumeral';
import { getImageSourceSetByProductCode } from '../../../util/ImageUtil';
import { convertToCurrencySymbol } from '../../../util/CurrencyUtil';
import { ProductTileCompact } from '../../product-tile/compact/ProductTileCompact';
export const EticketItem = ({ saleLine, currency }) => {
    const aemConfiguration = useAemConfig();
    const { rootWithLanguageSuffix, productImageConfig } = aemConfiguration;
    const productUrl = saleLine.url
        ? saleLine.colourId
            ? `${rootWithLanguageSuffix}/p${saleLine.url}.${saleLine.colourId}.html`
            : `${rootWithLanguageSuffix}/p${saleLine.url}.html`
        : '';
    const priceProps = {
        currency: convertToCurrencySymbol(currency) || currency,
        priceActual: {
            formattedPrice: AsNumeral.formatAsCurrency(saleLine.totalSellPrice),
        },
    };
    return (_jsx(ProductTileCompact, { asStatic: !productUrl, withoutInnerSpacing: true, brand: saleLine.brand, title: saleLine.productDescription, quantity: saleLine.quantity, url: productUrl, image: saleLine.picture
            ? getImageSourceSetByProductCode(saleLine.productCode, saleLine.picture, productImageConfig)[ProductImageSizesPortraitEnum.bundles]
            : '/content/dam/general/imagenotavailable.png', imageSize: "large", sizeDescription: saleLine.productSize, colorDescription: saleLine.productColour, priceProps: priceProps }));
};
